import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiStepperModule } from "@taiga-ui/kit";
import { KwikUIStepperComponent } from "./stepper.component";

@NgModule({
  declarations: [KwikUIStepperComponent],
  imports: [CommonModule, TuiStepperModule],
  exports: [KwikUIStepperComponent]
})
export class KwikUIStepperModule {}
